import { AppService } from './AppService';

export default class MenuService extends AppService {
  constructor({ http, auth, store }) {
    super({ http, auth, store });
  }

  fetchMenu({ languageIsoCode }) {
    return this.http.API.get(
      `menu?LanguageIsoCode=${languageIsoCode}`
    )
      .then((data) => {
        return data;
      })
      .catch((error) => {
        throw error;
      });
  }
}
